import { useQuery } from 'hooks/useQuery';
import { getVariableByName } from 'lib/api/variables';
import { HookQueryOptions, queryKey } from './shared';

export const useVariablesByNameQuery = (
  payload: { name: string },
  options?: HookQueryOptions
) =>
  useQuery(
    queryKey('variables.byName', payload),
    () => getVariableByName(payload?.name),
    { skip: options?.skip || !payload?.name }
  );
